// extracted by mini-css-extract-plugin
export default {"page":"Maintenance_page__JaHng"};